import { userClickCancelCardAction } from '@banking/ui/workflows/card-settings';
import { CardStatus, Relationship } from '@square/dashboard-protos/models/squareup/bbdebit/cardmanagement';
import { redirect } from '@square/dashboard-utilities/utils/window';
import { ControlType } from '@banking/ui/components/banking/checking/card-settings/management/setting';
import assert from '@banking/ui/utils/assert';
import productNameTranslationKey from '@banking/ui/utils/checking/product-name-translation-key';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { isCardExpired } from './card-settings-utils';
export const SUPPORT_ARTICLES_URL = 'https://squareup.com/help';
export const SUPPORT_ARTICLES_GB_URL = 'https://squareup.com/help/gb/article/6769';
export const getCardHelpSetting = (emit, t, productName, card) => () => {
  const icon = isCardExpired(card) ? 'alert-x-circle' : '24px-debit-card';
  const translationKey = isCardExpired(card) ? 'banking.checking.cardSettings.page.settings.closeAccount' : 'banking.checking.cardSettings.page.settings.getHelp';
  return {
    icon,
    text: t(productNameTranslationKey(productName, translationKey)),
    control: {
      type: ControlType.Regular,
      action: () => emit(userClickCancelCardAction())
    }
  };
};
export const getSupportArticlesLink = countryCode => {
  switch (countryCode) {
    case Country.US:
    case Country.CA:
      return SUPPORT_ARTICLES_URL;
    case Country.GB:
      return SUPPORT_ARTICLES_GB_URL;
    default:
      throw new Error('Country not supported');
  }
};
export const getSupportArticles = (t, countryCode) => () => {
  return {
    icon: '24px-question-circle-stroked',
    text: t('banking.checking.cardSettings.page.settings.supportArticles'),
    control: {
      type: ControlType.Regular,
      action: () => redirect(getSupportArticlesLink(countryCode))
    }
  };
};
export const getHelpSettings = (emit, t, productName, countryCode) => state => {
  if (state.loading) {
    return [];
  }
  assert(state.card != null);
  if (state.card.status === CardStatus.CARD_STATUS_TERMINATED || !state.card.relationship.includes(Relationship.RELATIONSHIP_CARDHOLDER)) {
    return [];
  }
  return [getCardHelpSetting(emit, t, productName, state.card)(), getSupportArticles(t, countryCode)()];
};